import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { Injectable } from '@angular/core';
import { BreakpointObserver, Breakpoints, BreakpointState } from '@angular/cdk/layout';
import { KillOnDestroy } from '@sg/utils';

export type LAYOUT_MODE = 'column' | 'row';

// Extended BreakpointState with breakpoint alias
export interface ExtendedBreakpointState extends BreakpointState {
  mqAlias?: 'xs' | 'sm' | 'md' | 'lg' | 'xl';
}

export interface Layout {
  mode: LAYOUT_MODE;
  mq: ExtendedBreakpointState;
}

@Injectable()
@KillOnDestroy()
export class SgMediaLayoutService {
  layout: Observable<Layout>;
  constructor(breakpointObserver: BreakpointObserver) {
    this.layout = <any>(
      breakpointObserver
        .observe([Breakpoints.XSmall, Breakpoints.Small, Breakpoints.Medium, Breakpoints.Large, Breakpoints.XLarge])
        .pipe(
          map((mq) => {
            // Determine breakpoint alias based on which breakpoint matches
            let mqAlias: 'xs' | 'sm' | 'md' | 'lg' | 'xl' = 'md';
            if (mq.breakpoints[Breakpoints.XSmall]) {
              mqAlias = 'xs';
            } else if (mq.breakpoints[Breakpoints.Small]) {
              mqAlias = 'sm';
            } else if (mq.breakpoints[Breakpoints.Medium]) {
              mqAlias = 'md';
            } else if (mq.breakpoints[Breakpoints.Large]) {
              mqAlias = 'lg';
            } else if (mq.breakpoints[Breakpoints.XLarge]) {
              mqAlias = 'xl';
            }

            // Check if it's medium or larger for row mode
            const isRowMode =
              mq.breakpoints[Breakpoints.Medium] ||
              mq.breakpoints[Breakpoints.Large] ||
              mq.breakpoints[Breakpoints.XLarge];

            const extendedMq: ExtendedBreakpointState = {
              ...mq,
              mqAlias,
            };

            return {
              mode: isRowMode ? 'row' : 'column',
              mq: extendedMq,
            };
          }),
          KillOnDestroy(this)
        )
    );
  }
}
